import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
};

const Avatar = ({ children }: Props) => (
	<div className="bg-interactive-primary text-text-contrast flex size-10 items-center justify-center rounded-full text-lg">
		{children}
	</div>
);

export default Avatar;
